import PluralUtil from 'common/util/PluralUtil';
import {component} from 'common/util/ComponentDecorator';
import compareService from 'common/util/compareService';
import favoriteService from 'common/util/favoriteService';

@component
export default class setPanel {
	static classname = 'set-panel';

	hide_timeout;

	constructor($panel) {
		this.$panel = $panel;

		this.bindEvents();
		this.bindGlobalEvents();
	}

	get hide_timeout_ms() {
		if (ResponsiveUtil.isDesktopUp()) {
			return 2000;
		} else {
			return 3500;
		}
	}

	get is_visible() {
		return this.$panel.hasClass('set-panel_visible');
	}

	set title(title) {
		this.$panel.find('.set-panel__title').html(title);
	}

	set icon(icon) {
		const $icon = $(icon);
		$icon.addClass('set-panel__icon');
		this.$panel.find('.set-panel__icon-wrapper').html($icon);
	}

	set product(product) {
		const $product = this.$panel.find('.set-panel__product');
		if (!product.name || !product.image) {
			$product.hide();
			return;
		} else {
			$product.show();
		}

		let { name, image } = product;
		image = image.replace(/([0-9]*)\.[x0-9]*((?:@2x)?\.[a-z]*)$/, '$1.60x60$2');

		this.$panel.find('.set-panel__product-name').html(name);
		this.$panel.find('.set-panel__product-image').attr('src', image).attr('alt', name);
	}

	set counter(counter) {
		const { label, value, sign } = counter;

		this.$panel.find('.set-panel__counter-label').html(label);
		this.$panel.find('.set-panel__counter-value').html(value);
		this.$panel.find('.set-panel__counter-sign').html(sign);
	}

	set button(button) {
		const { value, link } = button;

		this.$panel.find('.set-panel__button').html(value).attr('href', link);
	}

	bindEvents() {
		this.$panel.find('.set-panel__close-button').on('click', () => {
			this.hide();
		});

		this.$panel.on('mouseenter', () => {
			if (!this.is_visible) {
				return;
			}

			this.show(false);
		});

		this.$panel.on('mouseleave', () => {
			if (!this.is_visible) {
				return;
			}

			this.show();
		});
	}

	bindGlobalEvents() {
		compareService.addListenerAdd(product => {
			this.handleList(
				'Товар добавлен к сравнению',
				$(window.elkitorg_config.svg.compare).addClass('set-panel__icon_compare'),
				compareService.count(),
				product,
				'Перейти к сравнению',
				window.elkitorg_config.compare_url
			);
		});
		compareService.addListenerRemove(product => {
			this.handleList(
				'Товар удален из сравнения',
				$(window.elkitorg_config.svg.compare).addClass('set-panel__icon_compare'),
				compareService.count(),
				product,
				'Перейти к сравнению',
				window.elkitorg_config.compare_url
			);
		});
		favoriteService.addListenerAdd(product => {
			this.handleList(
				'Товар добавлен к избранное',
				$(window.elkitorg_config.svg.heart).addClass('set-panel__icon_favorite'),
				favoriteService.count(),
				product,
				'Перейти в избранное',
				window.elkitorg_config.favorite_url
			);
		});
		favoriteService.addListenerRemove(product => {
			this.handleList(
				'Товар удален из избранного',
				$(window.elkitorg_config.svg.heart).addClass('set-panel__icon_favorite'),
				favoriteService.count(),
				product,
				'Перейти в избранное',
				window.elkitorg_config.favorite_url
			);
		});
	}

	open(title, icon, product, counter, button) {
		clearTimeout(this.hide_timeout);

		this.title = title;
		this.icon = icon;
		this.product = product;
		this.counter = counter;
		this.button = button;

		this.show();
	}

	show(with_hide_timeout = true) {
		clearTimeout(this.hide_timeout);

		this.$panel.addClass('set-panel_visible');

		if (with_hide_timeout) {
			this.hide_timeout = setTimeout(() => {
				this.hide();
			}, this.hide_timeout_ms);
		}
	}

	hide() {
		clearTimeout(this.hide_timeout);

		this.$panel.removeClass('set-panel_visible');
	}

	handleList(title, $icon, count, product, buttonText, buttonUrl) {
		this.open(title, $icon, product, {
			label: 'Всего в списке',
			value: count,
			sign: PluralUtil(count, 'товар', 'товара', 'товаров')
		}, {
			value: buttonText,
			link: buttonUrl
		});
	}
}
